import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/fr';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(timezone);
dayjs.locale('fr');
